export { default } from "./buildRecentSearchesImpressionLabel";
